import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import ImpressumScreen from './ImpressumScreen';

const { FiPlay, FiClock, FiShield, FiTarget, FiAlertCircle } = FiIcons;

const WelcomeScreen = ({ onStart }) => {
  const [showImpressum, setShowImpressum] = useState(false);

  if (showImpressum) {
    return <ImpressumScreen onBack={() => setShowImpressum(false)} />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center p-4">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl mx-auto text-center"
      >
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
          <motion.div
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="mb-8"
          >
            <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <SafeIcon icon={FiTarget} className="w-10 h-10 text-white" />
            </div>
            
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              DISC Persönlichkeitstest
            </h1>
            
            <p className="text-xl text-gray-600 mb-8">
              Entdecken Sie Ihre Persönlichkeitstypen und passende Berufsfelder
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-6 mb-10">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="flex flex-col items-center p-4"
            >
              <SafeIcon icon={FiClock} className="w-8 h-8 text-blue-500 mb-3" />
              <h3 className="font-semibold text-gray-900 mb-2">Schnell</h3>
              <p className="text-gray-600 text-sm">Nur 10 Minuten für vollständige Analyse</p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="flex flex-col items-center p-4"
            >
              <SafeIcon icon={FiShield} className="w-8 h-8 text-green-500 mb-3" />
              <h3 className="font-semibold text-gray-900 mb-2">Anonym</h3>
              <p className="text-gray-600 text-sm">Keine Datenerfassung oder Speicherung</p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              className="flex flex-col items-center p-4"
            >
              <SafeIcon icon={FiTarget} className="w-8 h-8 text-purple-500 mb-3" />
              <h3 className="font-semibold text-gray-900 mb-2">Präzise</h3>
              <p className="text-gray-600 text-sm">Wissenschaftlich fundierte DISC-Methode</p>
            </motion.div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-6 mb-8">
            <h3 className="font-semibold text-gray-900 mb-3">Was Sie erhalten:</h3>
            <ul className="text-left text-gray-700 space-y-2">
              <li className="flex items-center">
                <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                Detaillierte Analyse Ihrer vier DISC-Persönlichkeitstypen
              </li>
              <li className="flex items-center">
                <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                Prozentuale Verteilung Ihrer Eigenschaften
              </li>
              <li className="flex items-center">
                <div className="w-2 h-2 bg-purple-500 rounded-full mr-3"></div>
                10 passende Berufsempfehlungen basierend auf Ihrem Profil
              </li>
            </ul>
          </div>

          <motion.div 
            className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 mb-8 text-sm text-yellow-800 flex items-start text-left"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            <SafeIcon icon={FiAlertCircle} className="w-5 h-5 mr-3 mt-0.5 flex-shrink-0" />
            <p>
              <strong>Wichtiger Hinweis:</strong> Das Testergebnis gibt lediglich einen ersten Anhaltspunkt zur Orientierung. 
              Wir übernehmen keine Haftung für die Richtigkeit der Analyse oder daraus abgeleitete Entscheidungen.
            </p>
          </motion.div>

          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={onStart}
            className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold py-4 px-8 rounded-2xl hover:from-blue-600 hover:to-indigo-700 transition-all duration-300 shadow-lg inline-flex items-center space-x-3"
          >
            <SafeIcon icon={FiPlay} className="w-5 h-5" />
            <span>Test starten</span>
          </motion.button>

          <p className="text-sm text-gray-500 mt-6">
            Der Test ist vollständig anonym. Ihre Daten werden nicht gespeichert oder übertragen.
          </p>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <button
              onClick={() => setShowImpressum(true)}
              className="text-sm text-gray-500 hover:text-blue-600 underline transition-colors"
            >
              Impressum
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default WelcomeScreen;